/**
 * Auth Slice
 * Why: Manage authentication state manually
 * What: Users data, login status,loading status
 * Benefit: Centralized auth state accessible anywhere
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IAuthState, IUser } from "./types";

/**
 * Initial State
 */
const initialState: IAuthState = {
  user: null,
  isLoading: false,
  isAuthenticating: false,
  isAuthenticated: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /**
     * Clear auth error
     */
    clearError: (state) => {
      state.error = null;
    },
    /**
     * Set user manually (e.g after token refresh)
     *
     */
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      // state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
  },
});

// Export actions
export const { clearError, setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
